import React from 'react';
import Navigation  from './Navigation';
import { useNavigationState } from '../../hooks/useNavigationState';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * レイアウトコンポーネント
 * アプリケーションの基本レイアウト構造を提供する
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  //#region ステート管理
  const { isExpanded } = useNavigationState();
  //#endregion

  //#region レンダリング
  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />
      <main
        className={`
          transition-all duration-300 ease-in-out
          ${isExpanded ? 'ml-64' : 'ml-16'}
          min-h-screen
        `}
      >
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
};
export default Layout;